var SendAssessmentResultsModalController = /** @class */ (function () {
    function SendAssessmentResultsModalController() {
        // this.jobMatchDetailsArray = this.resolve.jobMatchDetailsArray;
        // this.sendResultsArray = this.resolve.sendResultsArray;
    }
    SendAssessmentResultsModalController.prototype.$onInit = function () {
        var _this = this;
        this.jobMatchDetailsArray = this.resolve.jobMatchDetailsArray;
        this.sendResultsArray = this.resolve.sendResultsArray;
        this.label = 'Send Assessment Results';
        this.callbackObject = { callbackType: 'cancel', entity: {} };
        angular.forEach(this.sendResultsArray, function (val, key) {
            var jobMatchInfo = _.find(_this.jobMatchDetailsArray, { 'jobMatchId': val.jobMatchId });
            val.name = jobMatchInfo.jobMatchData.name;
        });
    };
    SendAssessmentResultsModalController.prototype.closeModal = function () {
        this.callbackObject.callbackType = "close";
        this.modalInstance.close(this.callbackObject);
    };
    SendAssessmentResultsModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return SendAssessmentResultsModalController;
}());
// import * as TEMPLATE from './send-assessment-results-modal.html;
import * as TEMPLATE from 'raw-loader!./send-assessment-results-modal.html';
export var SendAssessmentResultsModalComponent = {
    selector: 'sendAssessmentResultsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: SendAssessmentResultsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/shared/jobMatchActions/sendAssessment/sendAssessmentResultsModal/send-assessment-results-modal.html',
    }
};
//# sourceMappingURL=send-assessment-results-modal.component.js.map